import { render, staticRenderFns } from "./ListThemas.vue?vue&type=template&id=1dd60a54&"
import script from "./ListThemas.vue?vue&type=script&lang=js&"
export * from "./ListThemas.vue?vue&type=script&lang=js&"
import style0 from "./ListThemas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListThemas.vue"
export default component.exports